import { CommonDOMRenderer } from 'render-jsx/dom';
export const renderer = new CommonDOMRenderer();
